export enum DateFormatMask {
  /*
   * Business date should be captured/saved as ISO string format as UTC: 'YYYY-MM-DDT00:00:00.000Z'
   * without considering time zone offset.
   * Note that format 'YYYY-MM-DDT00:00:00.000Z' approved with Reporting team.
   */
  BUSINESS_DATE = 'YYYY-MM-DDT00:00:00.000[Z]',

  ISO_DATE = 'YYYY-MM-DD',
  ISO_TIME = 'HH:mm',
  ISO_TIME_SECONDS = 'HH:mm:ss',
  ISO_DATETIME_LOCAL = 'YYYY-MM-DDTHH:mm',
  ISO_DATETIME_LOCAL_MS = 'YYYY-MM-DDTHH:mm:ss.SSS',

  INPUT_PICKUP_DATE = 'DD.MM.YYYY',
  ELAPSED_TIME = 'mm:ss',

  LOGS_LIFETIME = 'YYYY-MM-DDT00:00:00.000[Z]',

  PAYMENT_DEVICE_REPORT_ID_DATE = 'MMDDYYHHmmss',
  PAYMENT_DEVICE_REPORT_DATE = 'YYYY.MM.DD',

  XGS_LOCAL_DATE = 'YYYYMMDD',
  XGS_LOCAL_TIME = 'hhmmss',

  DAY_NAME_SHORT = 'ddd',
  DAY_NAME_FULL = 'dddd',

  WORKFLOW_DATE_TIME = 'ddd MM/DD/YYYY h:mm A',
  WORKFLOW_TIME = 'h:mm A',

  ORDERS_WORKFLOW_DATE = 'MM/DD/YYYY',

  /*
   * `DISPLAY_...` masks represent format keys that used for locale based output
   */
  DISPLAY_TIME = 'LT',
  DISPLAY_TIME_SECONDS = 'LTS',
  DISPLAY_DATE = 'l',
  DISPLAY_DATE_TIME = 'l LT',
  DISPLAY_DATE_TIME_SECONDS = 'l LTS',
  DISPLAY_DATE_MONTH_LONG = 'LL',
}

export type DayNameFormat =
  | DateFormatMask.DAY_NAME_SHORT
  | DateFormatMask.DAY_NAME_FULL;
